import React from 'react';
import {Loader} from '../Loader/Loader';

class ScreenshotLogOverlay extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            opened: 0,
            url: null,
            isLoaded: null
        };

        this.showLogImage = this.showLogImage.bind(this);
        this.hideLogImage = this.hideLogImage.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.onError = this.onError.bind(this);
        this.onKeyCb = this.onKeyCb.bind(this);
    }

    componentDidMount() {
        window.addEventListener('showLogImage', this.showLogImage, false);
    }

    componentWillUnmount() {
        window.removeEventListener('showLogImage', this.showLogImage, false);
    }

    onKeyCb(e) {
        let keyCode = e.keyCode;

        if (keyCode === 27) {
            this.hideLogImage();
        }
    }

    onLoad() {
        this.setState({ isLoaded: true });
    }

    onError() {
        this.setState({ isLoaded: false });
    }

    showLogImage(e) {
        this.setState({ opened: true, url: e.detail.url });
        document.addEventListener('keydown', this.onKeyCb, false);
    }

    hideLogImage() {
        this.setState({ opened: false, url: null, isLoaded: null });
        document.removeEventListener('keydown', this.onKeyCb, false);
    }

    render() {
        const { opened, url, isLoaded } = this.state;
        return (
            <div className={`screenshot-log-overlay ${opened && 'opened'}`} onClick={this.hideLogImage} >
                <i className="icon icon-alan-hide-more" onClick={this.hideLogImage} />
                {isLoaded === null && <Loader theme="light" size="medium" center={true} />}
                {(url && isLoaded !== false) && <img src={`${url}`} onLoad={this.onLoad} onError={this.onError} className={`${isLoaded && 'visible-with-opacity'}`} />}
                {isLoaded === false && <div className="screenshot-log-overlay_error">Screenshot is not available now, please try again later</div>}
            </div>
        );
    }
}

export default ScreenshotLogOverlay;